// Automatically submit parent form when child input with class .form-autosubmit
document.querySelectorAll('.form-autosubmit').forEach(function (element) {
    element.addEventListener('change', function () {
        element.form.submit();
    });
});
